import * as angular from "angular";
import {IController} from "angular";

export class siteCommissionsViewCtrl implements IController {

  /* @ngInject */
  constructor() {
  }
}

angular
  .module('bringoz.admin.commissions')
  .component('siteCommissionsView', {
    bindings: {
    },
    template: require('./site-commissions-view.html').default,
    controller: siteCommissionsViewCtrl
  });
